import * as React from 'react';

import { ReMatterLogo, cn } from '@rematter/ui-web';
import { useAtom } from 'jotai';

import { CheckEmailMessage } from './components/CheckEmailMessage';
import { SignUpForm } from './components/SignUpForm';
import { SuccessAnimation } from './components/SuccessAnimation';
import { $signUp } from './state/signUp.state';

export const SignUp = () => {
  const [signUpState] = useAtom($signUp);

  const renderStep = () => {
    if (signUpState.completed) {
      return <SuccessAnimation />;
    }

    if (signUpState.step === 'complete') {
      return <CheckEmailMessage email={signUpState.email || ''} />;
    }

    return <SignUpForm />;
  };

  return (
    <div
      className={cn(
        '@SignUp',
        'relative flex min-h-screen items-center justify-center overflow-hidden p-5',
        'bg-gradient-to-b from-foreground/4 to-foreground/8',
      )}
    >
      <div
        className={cn(
          'relative z-10 flex w-full max-w-[500px] flex-col rounded-xl border border-abs-white/20 bg-space p-10 shadow-2xl shadow-primary/10 transition-[height] duration-300',
        )}
      >
        <div className="mb-6 flex justify-center">
          <ReMatterLogo size="large" height={50} />
        </div>
        {renderStep()}
      </div>
    </div>
  );
};
